// Frontend mirror of backend RBAC (backend is the enforcement source of truth)
export const ALL_PERMS = [
  "dashboard.view", "products.view", "products.create", "products.edit", "products.delete",
  "products.files", "orders.view", "orders.edit", "orders.refund", "customers.view",
  "customers.edit", "customers.export", "coupons.view", "coupons.manage", "cms.view",
  "cms.manage", "settings.view", "settings.manage", "social.manage", "staff.manage",
  "audit.view", "support.view", "support.manage",
  "payments.view", "payments.manage", "billing.manage", "invoices.view", "media.manage",
  "whatsapp.view", "whatsapp.manage",
];

const ADMIN_PERMS = new Set([
  "dashboard.view", "products.view", "products.create", "products.edit", "products.delete",
  "products.files", "orders.view", "orders.edit", "orders.refund", "customers.view",
  "customers.edit", "customers.export", "coupons.view", "coupons.manage", "cms.view",
  "cms.manage", "settings.view", "audit.view", "support.view", "support.manage",
  "payments.view", "payments.manage", "billing.manage", "invoices.view", "media.manage",
  "whatsapp.view", "whatsapp.manage",
]);

const STAFF_DEFAULT = new Set([
  "dashboard.view", "products.view", "orders.view", "customers.view", "support.view", "support.manage",
]);

const LEGACY = {
  content_manager: ["dashboard.view", "products.view", "products.create", "products.edit", "products.files", "cms.view", "cms.manage", "coupons.view", "coupons.manage"],
  order_manager: ["dashboard.view", "orders.view", "orders.edit"],
  support_staff: ["dashboard.view", "customers.view", "support.view", "support.manage"],
};

export function userPermissions(user) {
  if (!user) return new Set();
  const role = user.role || "customer";
  if (role === "super_admin") return new Set(ALL_PERMS);
  if (role === "admin") return new Set(ADMIN_PERMS);
  if (role === "staff") return new Set(user.permissions ?? [...STAFF_DEFAULT]);
  if (LEGACY[role]) return new Set(LEGACY[role]);
  return new Set();
}

export function can(user, permission) {
  return userPermissions(user).has(permission);
}
